/**
 * File: Tag.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.0
 * Created: 2026-02-18
 * Last Updated: 2026-02-18
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * A reusable UI tag for categorization or labeling.
 *
 * @param {Object} props - Component properties
 * @param {string} props.label - The text to display inside the tag
 * @returns {JSX.Element} A stylized inline-block element
 */
function Tag({ label }) {
    return (
        <>
            <p className="tag">{label}</p>
        </>
    );
}

export default Tag;
